import React from 'react';
import { Container, Row, Col, Card, Button, Badge } from 'react-bootstrap';
import LeadForm from './LeadForm.jsx';
import bg from './images/banner/423486644_0b6916fa-50d0-47e8-ac25-715d3d79af5f.jpg';
import {lawPageData} from './Data.jsx';
import { BsShieldCheck, BsArrowRightCircle, BsCheckCircle } from 'react-icons/bs';

export default function LawPage() {
  return (
    <div className="law-page">

      {/* HERO / БАННЕР */}
      <section
        className="law-hero d-flex align-items-center"
        style={{
          minHeight: '60vh',
          backgroundImage: `url(${bg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          position: 'relative',
          color: '#fff'
        }}
      >
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(90deg, rgba(0,0,0,.6), rgba(0,0,0,.15))'
          }}
        />
        <Container className="position-relative">
          <Row className="align-items-center">
            <Col lg={8}>
              <h1 className="fw-bold mb-3" style={{ textShadow: '0 2px 10px rgba(0,0,0,.5)' }}>
                {lawPageData.banner.title}
              </h1>
              <p className="lead mb-4" style={{ maxWidth: 800 }}>
                {lawPageData.banner.subtitle}
              </p>
              <Button
                size="lg"
                variant="light"
                href="#consultation"
                className="d-inline-flex align-items-center"
              >
                {lawPageData.banner.btn} <BsArrowRightCircle className="ms-2" />
              </Button>
            </Col>
          </Row>
        </Container>
      </section>

      {/* УСЛУГИ */}
      <section className="py-5 bg-light">
        <Container>
          <Row className="mb-4">
            <Col>
              <h2 className="h3 fw-bold mb-2">{lawPageData.services.title}</h2>
              <p className="text-muted mb-0">{lawPageData.services.subtitle}</p>
            </Col>
          </Row>

          <Row xs={1} md={2} lg={4} className="g-4">
            {lawPageData.services.items.map((service, idx) => (
              <Col key={idx}>
                <Card className="h-100 border-0 shadow-sm">
                  <Card.Body className="text-center">
                    <div className="mb-3" style={{ fontSize: '2.5rem', color: '#343a40' }}>
                      <service.icon />
                    </div>
                    <Card.Title className="fw-bold">{service.title}</Card.Title>
                    <Card.Text className="text-muted">{service.text}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* КАК ПОЛУЧИТЬ ПОМОЩЬ */}
      <section className="py-5">
        <Container>
          <Row className="mb-4">
            <Col>
              <h2 className="h3 fw-bold mb-2">{lawPageData.howGetHelp.title}</h2>
              <p className="text-muted mb-0">{lawPageData.howGetHelp.subtitle}</p>
            </Col>
          </Row>

          <Row className="g-4">
            {lawPageData.howGetHelp.items.map((step) => (
              <Col md={6} key={step.step}>
                <Card className="h-100 border-0 shadow-sm">
                  <Card.Body className="d-flex">
                    <Badge bg="dark" pill className="me-3 align-self-start">{step.step}</Badge>
                    <div>
                      <Card.Text className="mb-0">{step.text}</Card.Text>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* ПОЧЕМУ ИМЕННО МЫ */}
      <section className="py-5 bg-light">
        <Container>
          <Row className="mb-4">
            <Col>
              <h2 className="h3 fw-bold mb-2">{lawPageData.whyWe.title}</h2>
              <p className="text-muted mb-0">{lawPageData.whyWe.descr}</p>
            </Col>
          </Row>

          <Row>
            <Col lg={10}>
              <ul className="list-unstyled fs-5">
                {lawPageData.whyWe.list.map((item, idx) => (
                  <li className="d-flex align-items-start mb-2" key={idx}>
                    <BsCheckCircle className="me-2 mt-1 text-success" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </Col>
          </Row>
        </Container>
      </section>

      {/* БЕСПЛАТНАЯ КОНСУЛЬТАЦИЯ (с формой) */}
      <section id="consultation" className="py-5">
        <Container>
          <Row className="mb-4">
            <Col>
              <h2 className="h3 fw-bold mb-2">{lawPageData.contact.title}</h2>
              <p className="text-muted mb-0">{lawPageData.contact.subtitle}</p>
            </Col>
          </Row>

          <Row className="g-4">
            <Col lg={6}>
              <Card className="shadow-sm border-0">
                <Card.Body>
                  {/* Используем вашу существующую форму */}
                  <LeadForm additional={'Заявка со страницы /law'} />
                </Card.Body>
              </Card>
            </Col>
            <Col lg={6}>
              <Card className="shadow-sm border-0 h-100">
                <Card.Body>
                  <h5 className="fw-bold mb-3">{lawPageData.whatYouGet.title}</h5>
                  <ul className="list-unstyled mb-4">
                    {lawPageData.whatYouGet.items.map((item, idx) => (
                      <li className="d-flex align-items-start mb-2" key={idx}>
                        <BsCheckCircle className="me-2 mt-1 text-success" />
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                  <p className="text-muted small mb-0">
                    {lawPageData.whatYouGet.afterListText}
                  </p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

    </div>
  );
}
